module.exports = __webpack_public_path__ + "2a9543d30c617180c97ee9891464e20b.png";